<template>
  <BlBackdrop
    title="New ABC data"
    label="Add"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onCreate"
  >
    <div
      class="grid grid-cols-6 items-center gap-4 px-8 overflow-y-auto"
      :style="{ width: '48rem', maxHeight: 'calc(100vh - 14rem)' }"
    >
      <BlInputText
        class="col-span-6"
        :input="observerNameInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlInputDate
        class="col-span-2"
        :input="dateOfObservationInput"
        @changed="inputHandler"
      />
      <BlInputTime
        class="col-span-2"
        :input="startInput"
        @changed="inputHandler"
      />
      <BlInputTime
        class="col-span-2"
        :input="endInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlInputText
        class="col-span-6"
        :input="antecedentInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlInputText
        class="col-span-6"
        :input="behaviorInput"
        @changed="inputHandler"
      />
      <!--  -->
      <BlInputText
        class="col-span-6"
        :input="consequenceInput"
        @changed="inputHandler"
      />
      <!--  -->
      <div
        v-for="(input, i) in checkInput"
        :key="i"
        class="col-span-3 flex items-center gap-2 cursor-pointer"
        @click="checkInput[i].checked = !input.checked"
      >
        <BlInputCheck :checked="input.checked" />
        <BlTextBody2 :text="input.name" class="text-slate-1000" />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputDate from "../../BlInputDate.vue";
import BlInputTime from "../../BlInputTime.vue";
import BlInputCheck from "../../BlInputCheck.vue";

export default {
  name: "NewAssessmentModal",
  components: {
    BlBackdrop,
    BlTextBody2,
    BlInputText,
    BlInputDate,
    BlInputTime,
    BlInputCheck
  },
  data() {
    return {
      submitLoading: false,
      observerNameInput: {
        label: "Observer name",
        placeholder: "Type name",
        asterisk: true,
        model: ""
      },
      dateOfObservationInput: {
        label: "Date of observation",
        model: moment().format("YYYY-MM-DD")
      },
      startInput: { label: "Time start", model: "", format: ["h", "m"] },
      endInput: { label: "Time end", model: "", format: ["h", "m"] },
      antecedentInput: {
        label: "Antecedent",
        placeholder: "Describe the actions that precede the behavior",
        textarea: true,
        model: ""
      },
      behaviorInput: {
        label: "Behavior",
        placeholder: "Describe exactly what happened",
        textarea: true,
        model: ""
      },
      consequenceInput: {
        label: "Consequence",
        placeholder: "Events that followed the behavior",
        textarea: true,
        model: ""
      },
      checkInput: [
        {
          name: "Escape/Avoidance",
          value: "escape_or_avoidance",
          checked: false
        },
        {
          name: "Expression of Anger",
          value: "expression_of_anger",
          checked: false
        },
        {
          name: "Gaining Attention",
          value: "gaining_attention",
          checked: false
        },
        { name: "Frustration", value: "frustation", checked: false },
        {
          name: "Obtain Tangible Item",
          value: "obtain_tangible_item",
          checked: false
        },
        { name: "Fear/Anxiety", value: "fear_or_anxiety", checked: false },
        {
          name: "Sensory Stimulation",
          value: "sensory_stimulation",
          checked: false
        },
        { name: "Other", value: "other", checked: false }
      ]
    };
  },
  computed: {
    ...mapGetters(["client"]),
    isDisabledSubmit() {
      if (this.submitLoading) return true;
      // Basic checks
      if (!this.observerNameInput.model) return true;
      return false;
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["createAssessment"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onCreate() {
      const data = {
        id: this.client.id,
        assessment: {
          observer: this.observerNameInput.model,
          date: this.dateOfObservationInput.model,
          start_time: this.startInput.model,
          end_time: this.endInput.model,
          antecedent: this.antecedentInput.model,
          behavior: this.behaviorInput.model,
          consequence: this.consequenceInput.model,
          escape_or_avoidance: this.checkInput[0].checked,
          expression_of_anger: this.checkInput[1].checked,
          gaining_attention: this.checkInput[2].checked,
          frustation: this.checkInput[3].checked,
          obtain_tangible_item: this.checkInput[4].checked,
          fear_or_anxiety: this.checkInput[5].checked,
          sensory_stimulation: this.checkInput[6].checked,
          other: this.checkInput[7].checked
          // default: true
        }
      };
      this.submitLoading = true;
      this.createAssessment(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.$emit("close-modal");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/about/NewAssessmentModal.vue